import request from '@/utils/request'

/**
 * 字典详细列表(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function dictionaryDetailList(data) {
  return request({
    type: 'biz',
    url: 'dictionary/detail/list',
    method: 'post',
    data
  })
}

/**
 * 字典详细列表(父节点不为空)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function dictionaryParentnotnullDetailList(data) {
  return request({
    type: 'biz',
    url: 'dictionary/parentNotNull/detail/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Dictionary.js